import i18n from 'i18next';

interface Dictionary<Value> {
    [id: string]: Value;
}

export const mapDictionaryToOptions = (dictionary: Dictionary<string>) =>
    Object.keys(dictionary).map((el: string) => ({label: dictionary[el], value: el}));

export const mapEnumToI18nOptions = (list: any, scope: string) =>
    Object.keys(list).map((el: string) => ({label: i18n.t(`${scope}.${el}`), value: el}));

export const mapArrayToI18nOptions = (list: {key: any; value: any}[], scope: string) =>
    list.map((item) => ({label: i18n.t(`${scope}.${item.key}`), value: item.value}));

export const mapValueIfKeyExist = (path: string, value: string) => {
    const result = path + value;
    return i18n.exists(result) ? result : value;
};

export const mapStorageTypesToI18nOptions = (list: number[], scope: string) =>
    list.map((el: number) => ({label: i18n.t(`${scope}.${el}.label`), value: el}));

export const yearsOptions = (first = 2020, last = new Date().getFullYear()) => {
    let current = first;
    const list: number[] = [];

    while (current <= last) {
        list.push(current);
        current++;
    }

    return list.map((y) => ({label: y, value: y}));
};
